const toggleAddressData = {
	exclusive: true,
	size: 'small',
	color: 'primary',
	fullWidth: false,
	orientation: 'horizontal',
	buttons: [
		{ id: '1', value: 'addressWork', label: 'WORK' },
		{ id: '2', value: 'addressHome', label: 'HOME' },
		{ id: '3', value: 'addressOther', label: 'OTHER' },
	],
};

export default toggleAddressData;
